import { createContext, useEffect, useState } from "react";

const NewOrderContext = createContext();

const NewOrderContextProvider = ({ children }) => {
  const [lineNumberInfo, setLineNumberInfo] = useState(null);
  const [generalInfo, setGeneralInfo] = useState(null);
  const [vendorGeneralInfoList, setVendorGeneralInfoList] = useState([]);
  const [vendorLineNumberInfoList, setVendorLineNumberInfoList] = useState([]);
  const [countDetails, setCountDetails] = useState(0);


  return (
    <NewOrderContext.Provider
      value={{
        lineNumberInfo,
        setLineNumberInfo,
        vendorLineNumberInfoList,
        setVendorLineNumberInfoList,
        generalInfo,
        setGeneralInfo,
        countDetails,
        setCountDetails,
        vendorGeneralInfoList,
        setVendorGeneralInfoList,
      }}
    >
      {children}
    </NewOrderContext.Provider>
  );
};

export { NewOrderContext, NewOrderContextProvider };
